import script from "./CaptionBeats.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptionBeats.vue?vue&type=script&setup=true&lang=js"

import "./CaptionBeats.vue?vue&type=style&index=0&id=48babc73&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48babc73"]])

export default __exports__